import type { WindowKey } from 'owa-bizchat-types';
import { getStore } from '../store/store';

/** Indicates if the Tasks Hub is active/visible in the given window. */
export const isActive = (windowKey: WindowKey): boolean => {
    return getStore().activeWindows.get(windowKey) ?? false;
};
